var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingImageN2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28 20V18.98L13.1 13.28C13.6333 12.76 14.0333 12.3067 14.3 11.92C14.5667 11.52 14.7467 11.1467 14.84 10.8C14.9333 10.4533 14.98 10.1267 14.98 9.82C14.98 9.00667 14.7 8.36667 14.14 7.9C13.5933 7.43333 12.78 7.2 11.7 7.2C10.8733 7.2 10.14 7.32667 9.5 7.58C8.87333 7.83333 8.33333 8.22667 7.88 8.76L6.86 7.88C7.40667 7.24 8.10667 6.74667 8.96 6.4C9.81333 6.05333 10.7667 5.88 11.82 5.88C12.7667 5.88 13.5867 6.03333 14.28 6.34C14.9733 6.63333 15.5067 7.06667 15.88 7.64C16.2667 8.21333 16.46 8.88667 16.46 9.66C16.46 10.1133 16.3933 10.56 16.26 11C16.14 11.44 15.9133 11.9067 15.58 12.4C15.26 12.88 14.7867 13.4267 14.16 14.04L8.82 19.28L8.42 18.72H17.1V20H7.28Z",
    fill: "#3063E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 23.5,
    height: 23.5,
    rx: 11.75,
    stroke: "#3063E9",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingImageN2);
export default __webpack_public_path__ + "static/media/landingImageN2.1bbcdd46eec6dbb97a8fc30d3dd3b2ca.svg";
export { ForwardRef as ReactComponent };